import { lazy } from 'react';
import { config } from './config';

export const funnel = {
  ...config,
  Funnel: lazy(() => import('./funnel').then(m => ({ default: m.Funnel }))),
};
